// extracted by mini-css-extract-plugin
module.exports =  {"root":"GApVcPeNlDp9_Za1Vtsm","label":"tsYdL08hiISZyQCkjvQQ","hideControls":"FH2h2YXiy5vNGq6XQo6J","info":"LCqtqmqf9wzxfZDtmdZe"};